<template>
  <tr :class="isOption && item.packages ? 'package-option' : ''">
    <td><i class="fa fa-fw fa-link" v-if="isOption"></i>{{ id }}</td>
    <td v-if="hasPartialReservations">
      <div v-for="(reservation, index) in reservations" class="partial-reservation-item">
        <div class="btn-group"><a class="btn btn-default btn-partial-reservation" href="javascript:;" v-on:click="reservationClicked(reservation)"><i class="fa fa-fw fa-calendar"></i> {{ name }} ({{ index + 1 }} / {{ reservationCount }})</a></div>
        <div class="flex-row">
          <template v-for="resource in reservation.sharedResource">
            <!-- <a class="btn btn-sm btn-info" href="javascript:;" v-on:click="resourceClicked(resource)"><i class="fa fa-fw fa-cube"></i> {{ resource.name }}</a> -->
            <a class="btn btn-sm btn-info" href="javascript:;" v-on:click="reservationClicked(reservation)">
              <template v-if="item.packages && getPackageDescription(item)"><i class="fa fa-fw fa-sitemap"></i> {{ getPackageDescription(item) }}&nbsp;</template>
              <i class="fa fa-fw fa-cube"></i> {{ resource.id }}: {{ resource.name }}</a>
            <a class="btn btn-sm btn-info" href="javascript:;" v-for="seat in getResourceSeats(resource)" v-html="getSeatName(resource, seat).replace(' ', '&nbsp;')" v-on:click="seatClicked(seat)"></a>
          </template>
        </div>
        <div v-if="!(item.item_id && item.packages)">
          <span v-if="reservation" class="partial-reservation-desc">
            <i class="fa fa-fw fa-clock"></i> {{ getReservationDesc(reservation) }}
          </span>
        </div>
      </div>
      <div><label>{{ _('Reserved on') }}</label></div>
      <small style="color: #666" v-if="previousReservation">({{ _('was') }} {{ getReservationDesc(previousReservation) }})</small>
      <template v-if="item.rateplan_name">
        <div style="margin-top: 10px;"><label>{{ _('Rate plan') }}</label></div>
        <div>{{ item.rateplan_name }}</div>
      </template>
      <div style="margin-top: 10px;"><label>{{ _('Participants') }}</label></div>
      <div v-if="item.pricetiers" v-html="getPricetierDescription(item)"></div>
      <div v-else>{{ item.reservation_count }}</div>
      <div v-if="item.special && item.special !== 'groupdeal' && item.special !== 'margin_travel_agent' && item.special !== 'null'"><i>{{ item.special }}</i></div>
      <div v-if="formResponse" style="font-size: 0.9em">
        <div v-for="(value, key) in formResponse" :key="key">
          <strong>{{ key }}:</strong> <span style="white-space: pre-line">{{ value }}</span>
        </div>
      </div>
    </td>
    <td v-else>
      <div class="btn-group"><a class="btn btn-default" href="javascript:;" v-on:click="reservationClicked(reservation)"><i class="fa fa-fw fa-calendar"></i> {{ name }}</a></div>
      <div class="flex-row">
        <template v-for="resource in resources">
          <!-- <a class="btn btn-sm btn-info" href="javascript:;" v-on:click="resourceClicked(resource)"><i class="fa fa-fw fa-cube"></i> {{ resource.name }}</a> -->
          <a class="btn btn-sm btn-info" href="javascript:;" v-on:click="reservationClicked(reservation)">
            <template v-if="item.packages && getPackageDescription(item)"><i class="fa fa-fw fa-sitemap"></i> {{ getPackageDescription(item) }}&nbsp;</template>
            <i class="fa fa-fw fa-cube"></i> {{ resource.id }}: {{ resource.name }}</a>
          <a class="btn btn-sm btn-info" href="javascript:;" v-for="seat in getResourceSeats(resource)" v-html="getSeatName(resource, seat).replace(' ', '&nbsp;')" v-on:click="seatClicked(seat)"></a>
        </template>
      </div>
      <div v-if="!(item.item_id && item.packages)">
        <div><label>{{ _('Reserved on') }}</label></div>
        <span v-if="reservation">
          {{ getReservationDesc(reservation) }}
          <small style="color: #666" v-if="previousReservation"><br />({{ _('was') }} {{ getReservationDesc(previousReservation) }})</small>
        </span>
        <span v-else-if="item.reservation_desc">
          <small style="color: #666">({{ item.reservation_desc }})</small>
        </span>
        <div v-if="reservation && item.rateplan_name"><label>{{ _('Rate plan') }}</label></div>
        <div v-if="reservation && item.rateplan_name">{{ item.rateplan_name }}</div>
        <div><label>{{ _('Participants') }}</label></div>
        <div v-if="item.pricetiers" v-html="getPricetierDescription(item)"></div>
        <div v-else>{{ item.reservation_count }}</div>
        <div v-if="item.special && item.special !== 'groupdeal' && item.special !== 'margin_travel_agent' && item.special !== 'null'"><i>{{ item.special }}</i></div>
        <div v-if="formResponse" style="font-size: 0.9em">
          <div v-for="(value, key) in formResponse" :key="key">
            <strong>{{ key }}:</strong> <span style="white-space: pre-line">{{ value }}</span>
          </div>
        </div>
      </div>
    </td>
    <td>
      <span v-if="item.resource_count > 1">{{ item.resource_count }} {{ _('pcs') }}, </span>
      <abbr v-if="item.pricetiers" :title="getPricetierDescription(item)">{{ item.reservation_count }}</abbr>
      <span v-else>{{ item.reservation_count }}</span>
    </td>
    <td class="hidden-print">{{ $filters.currency(item.price, item.currency) }}</td>
    <td class="hidden-print">{{ $filters.currency(item.price * item.count * Math.max(item.resource_count, 1), item.currency) }}</td>
  </tr>
</template>

<script>
import { DateTime } from 'luxon'
import orderitems from '~/lib/orderitems'
import { mapGetters } from 'vuex'

export default {
  mixins: [orderitems],
  props: ['isOption', 'item', 'parentItem'],
  computed: {
    ...mapGetters(['dateFormat', 'timeFormat', 'timezone']),
    resources () {
      return this.reservation ? this.reservation.sharedResource : []
    },
    seats () {
      return this.reservation ? this.reservation.sharedSeat : []
    },
    reservation () {
      return this.item.ownReservation && this.item.ownReservation[0] ? this.item.ownReservation[0] : null
    },
    reservations () {
      return this.item.ownReservation
    },
    reservationCount () {
      return this.reservations ? this.reservations.length : 0
    },
    hasPartialReservations () {
      return this.reservations && this.reservations.length > 1 && this.reservations.some(r => r && r.partial)
    },
    previousReservation () {
      if (!this.reservation) {
        return null
      }
      if (this.item.start_ts !== this.reservation.start_ts || this.item.end_ts !== this.reservation.end_ts) {
        return { start_ts: this.item.start_ts, end_ts: this.item.end_ts }
      }
      return null
    },
    formResponse() {
      if (!this.item.formresponse) {
        return null
      }
      try {
        return JSON.parse(this.item.formresponse)
      } catch {
        return this.item.formresponse
      }
    }
  },
  methods: {
    getSeatName(resource, seat) {
      if (resource.seatmap) {
        const data = JSON.parse(resource.seatmap.data)
        if (data && data.seats) {
          const s = data.seats.find(s => parseInt(s.seat, 10) === parseInt(seat.id))
          if (s) {
            return s.header + ' / ' + s.title
          }
        }
      }
      return ''
    },
    getPricetierDescription (item) {
      if (!item.pricetiers || !item.product || !item.product.sharedPricetier || !item.product.sharedPricetier.length) {
        return ''
      }
      const tiers = item.pricetiers.split(';')
      let ret = []
      for (let i = 0; i < tiers.length; i++) {
        let [id, count] = tiers[i].split(':')
        const pt = item.product.sharedPricetier.find(p => parseInt(p.id, 10) === parseInt(id, 10))
        if (pt) {
          ret.push(pt.name + ': ' + count)
        }
      }
      return ret.join(', ')
    },
    getPackageDescription (item) {
      if (!item.packages || !this.parentItem || !this.parentItem.packages) {
        return ''
      }
      const itemRef = JSON.parse(item.packages).itemRef
      const parentPackages = JSON.parse(this.parentItem.packages)
      let ret = ''
      parentPackages.forEach(participant => {
        const product = participant.products.find(p => p.itemRef === itemRef)
        if (product) {
          ret = product.resourcePools[0] ? product.resourcePools[0].name : product.name
          return
        }
      })
      return ret
    },
    getResourceSeats (resource) {
      if (resource.seatmap_id && this.seats && this.seats.length) {
        return this.seats.filter(s => s.resource_id === resource.id)
      }
      return []
    },
    getReservationDesc(reservation) {
      let s = ''
      const _ = this._
      const sd = DateTime.fromSeconds(Number(reservation.start_ts), { zone: this.timezone })
      let ed = DateTime.fromSeconds(Number(reservation.end_ts), { zone: this.timezone })
      let et = ed.toFormat(this.timeFormat)
      if (et === '0.00') {
        et = '24.00'
        ed = ed.minus({ days: 1 })
      }
      s += sd.toFormat(this.dateFormat) + ' ' + _('at') + ' ' + sd.toFormat(this.timeFormat)
      s += ' - '
      if (sd.toFormat('yyyy/MM/dd') !== ed.toFormat('yyyy/MM/dd')) {
        s += ed.toFormat(this.dateFormat) + ' ' + _('at') + ' '
      }
      s += et
      // If start and end are on different days, add the duration in days
      if (sd.toFormat('yyyy/MM/dd') !== ed.toFormat('yyyy/MM/dd')) {
        const durationDays = ed.startOf('day').diff(sd.startOf('day'), 'days').days
        s += ` / ${durationDays} ${_('days')}`
      }
      return s
    }
  }
}
</script>

<style scoped>
tr.package-option > td:first-child {
  background-color: #d9edf7;
}
.btn-partial-reservation {
  background-color: #ffe066;
  border-color: #ffc107;
}
.partial-reservation-item {
  margin-bottom: 10px; 
  border-bottom: 1px solid #ccc; 
  padding-bottom: 10px;
}
.partial-reservation-desc {
  display: inline-block; 
  margin-left: 14px; 
  padding-top: 8px;
}
</style>